<template>
  <div class="login-container">
    <div class="login-wrapper">
      <el-card class="login-card">
        <div class="login-header">
          <div class="logo-container">
            <img src="@/assets/logo.png" alt="Mild插件" class="login-logo">
          </div>
          <h2 class="login-title">用户登录</h2>
          <p class="login-subtitle">欢迎回来，请登录您的账号</p>
        </div>

        <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="rules"
            label-width="0px"
            @submit.native.prevent="handleLogin"
            class="login-form"
        >
          <el-form-item prop="account">
            <el-input
                v-model="loginForm.account"
                placeholder="请输入账号"
                prefix-icon="el-icon-user"
                clearable
                size="medium"
                class="form-input"
            ></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                clearable
                show-password
                size="medium"
                @keyup.enter.native="handleLogin"
                class="form-input"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
                type="primary"
                :loading="loading"
                @click="handleLogin"
                class="login-btn"
                size="medium"
            >
              {{ loading ? '登录中...' : '登 录' }}
            </el-button>
          </el-form-item>

          <div class="login-footer">
            <el-link type="primary" :underline="false" class="footer-link">忘记密码？</el-link>
            <el-link type="primary" :underline="false" class="footer-link">注册账号</el-link>
          </div>
        </el-form>
      </el-card>
      <div class="login-bg"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserLogin',
  data() {
    return {
      loginForm: {
        account: '',
        password: ''
      },
      loading: false,
      rules: {
        account: [
          {required: true, message: '请输入账号', trigger: 'blur'},
          {min: 3, max: 20, message: '账号长度在 3 到 20 个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true

          // 发送 POST 请求到后端
          this.$axios({
            method: 'post',
            url: '/login',
            data: {
              username: this.loginForm.account,
              password: this.loginForm.password
            }
          }).then(response => {
            // 处理响应
            if (response.data.code === "200" || response.data.success) {
              alert(response.data.data.message)

              if (response.data.data && response.data.token) {
                localStorage.setItem('token', response.data.token)
              }
              localStorage.setItem('userInfo', JSON.stringify(response.data.data))
              this.$router.push('/home')
            }
            if (response.data.code === "203") {
              alert(response.data.data.message)
            }
          }).catch(error => {
            alert("error" + error)
          }).finally(() => {
            // 无论成功还是失败，最终都会执行这里
            this.loading = false
          })
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
/* 修复白色高度条 - 使用 fixed 定位占满全屏 */
.login-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.login-wrapper {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 450px;
  padding: 20px;
}

.login-card {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  overflow: hidden;
  animation: cardSlideIn 0.6s ease-out;
}

.login-header {
  text-align: center;
  padding: 30px 0 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.logo-container {
  margin-bottom: 15px;
  animation: logoBounce 1s ease-out;
}

.login-logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background: white;
  padding: 10px;
}

.login-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 8px 0;
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

.login-subtitle {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
  animation: fadeInUp 0.6s ease-out 0.4s both;
}

.login-form {
  padding: 30px;
}

.form-input {
  animation: fadeInUp 0.6s ease-out 0.6s both;
}

.login-btn {
  width: 100%;
  margin-top: 20px;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out 0.8s both;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.login-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  animation: fadeInUp 0.6s ease-out 1s both;
}

.footer-link {
  font-size: 14px;
  transition: all 0.3s ease;
}

.footer-link:hover {
  color: #667eea;
  transform: translateY(-1px);
}

/* 输入框样式优化 */
::v-deep .el-input__inner {
  height: 48px;
  line-height: 48px;
  border-radius: 8px;
  border: 1px solid #e1e5eb;
  transition: all 0.3s ease;
}

::v-deep .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

::v-deep .el-form-item {
  margin-bottom: 24px;
}

/* 背景装饰 */
.login-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.login-bg::before,
.login-bg::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.login-bg::before {
  width: 300px;
  height: 300px;
  top: -100px;
  right: -100px;
  animation-delay: 0s;
}

.login-bg::after {
  width: 200px;
  height: 200px;
  bottom: -50px;
  left: -50px;
  animation-delay: 3s;
}

/* 动画效果 */
@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes logoBounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-wrapper {
    padding: 10px;
  }
  
  .login-card {
    max-width: 95%;
  }
  
  .login-header {
    padding: 20px 0 15px;
  }
  
  .login-logo {
    width: 60px;
    height: 60px;
  }
  
  .login-title {
    font-size: 24px;
  }
  
  .login-form {
    padding: 20px;
  }
}
</style>